export const LANDING_PAGE = "/bootcamps/waves.svg";
